import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {MatChip, MatChipSet} from '@angular/material/chips';
import {TruncateDirective} from '@aviary/directives/truncate.directive';
import {SelectPipe} from '@aviary/pipes/select.pipe';
import {Patron} from '@store/patron/patron.types';
import {PatronSelectors} from '@store/patron/patron.selectors';

@Component({
  selector: 'px-patron-status',
  template: `
    <mat-chip-set>
      <mat-chip mxTruncate color="{{ selectors.categoryColorFor(patron) | select }}">{{ selectors.categoryNameFor(patron) | select }}</mat-chip>
    </mat-chip-set>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatChipSet, MatChip, TruncateDirective, SelectPipe]
})
export class PatronStatusComponent {

  @Input() public patron: Patron;

  public readonly selectors = PatronSelectors.Stateless;
}
